import {
  safeRequestAnimationFrame,
  safeSetTimeout,
} from "@-/dev.improve.haniverse.lib.scheduler";

/** Keep frame coalescing without requiring a foreground surface to dispatch database reads. */
export function scheduleDataloaderBatch(callback: () => void): void {
  let dispatched = false;
  const dispatch = () => {
    if (dispatched) {
      return;
    }
    dispatched = true;
    clearTimeout(timer);
    cancelFrame();
    callback();
  };
  // Frames pause in backgrounded apps/tabs. A timer can dispatch as soon as JS timers run,
  // including before the next paint on resume. It does not change the query's deadline.
  const timer = safeSetTimeout(dispatch, 50, "dataloader-batch");
  const cancelFrame = safeRequestAnimationFrame(dispatch, "dataloader-batch");
}
